import script from "./WritingRecordDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./WritingRecordDetail.vue?vue&type=script&setup=true&lang=js"

import "./WritingRecordDetail.vue?vue&type=style&index=0&id=3cff48fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cff48fc"]])

export default __exports__